// extracted by mini-css-extract-plugin
export default {"pageWrapper":"styles_pageWrapper__tdjPQ","mobilePageWrapper":"styles_mobilePageWrapper__u8c8L","noPadding":"styles_noPadding__sB4pm"};